import { render } from "./detail.vue?vue&type=template&id=86c6f3ea&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=86c6f3ea&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__